import { render } from "./SourceBlock.vue?vue&type=template&id=5b055b1e"
import script from "./SourceBlock.vue?vue&type=script&lang=js"
export * from "./SourceBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/SourceBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b055b1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b055b1e', __exports__)) {
    api.reload('5b055b1e', __exports__)
  }
  
  module.hot.accept("./SourceBlock.vue?vue&type=template&id=5b055b1e", () => {
    api.rerender('5b055b1e', render)
  })

}


export default __exports__